(function () {
  var announcement = document.querySelector('.site-announcement');
  var header = document.querySelector('.site-header');
  if (!header) return;

  header.style.transition = 'transform 300ms ease';
  header.style.webkitTransition = 'transform 300ms ease';
  header.style.willChange = 'transform';
  if (announcement) {
    announcement.style.transition = 'transform 300ms ease, opacity 300ms ease';
    announcement.style.webkitTransition = 'transform 300ms ease, opacity 300ms ease';
    announcement.style.willChange = 'transform';
    announcement.style.overflow = 'hidden';
  }

  var announcementHeight = announcement ? announcement.offsetHeight : 0;
  var headerOwnHeight = header.offsetHeight;
  var topThreshold = 5;
  var upTolerance = 10;
  var downTolerance = 10;

  var announcementVisible = true;
  var headerVisible = true;
  var scrollDelta = 0;

  function getScrollY() {
    return Math.max(window.pageYOffset || window.scrollY || 0, 0);
  }
  var lastScrollY = getScrollY();

  function render() {
    if (announcement) {
      if (announcementVisible) {
        announcement.style.transform = 'translate3d(0,0,0)';
        announcement.style.opacity = '1';
        announcement.style.pointerEvents = '';
      } else {
        announcement.style.transform = 'translate3d(0,-100%,0)';
        announcement.style.opacity = '0';
        announcement.style.pointerEvents = 'none';
      }
    }

    var headerOffset;
    if (!headerVisible) {
      headerOffset = -(announcementHeight + headerOwnHeight);
    } else if (!announcementVisible) {
      headerOffset = -announcementHeight;
    } else {
      headerOffset = 0;
    }
    header.style.transform = 'translate3d(0,' + headerOffset + 'px,0)';
    header.style.webkitTransform = 'translate3d(0,' + headerOffset + 'px,0)';
  }

  function update() {
    var y = getScrollY();
    var diff = y - lastScrollY;

    if (y <= topThreshold) {
      announcementVisible = true;
      headerVisible = true;
      scrollDelta = 0;
    } else {
      announcementVisible = false;

      if (diff > 0) {
        scrollDelta = scrollDelta > 0 ? scrollDelta + diff : diff;
        if (scrollDelta > downTolerance && y > headerOwnHeight) {
          headerVisible = false;
          scrollDelta = 0;
        }
      } else if (diff < 0) {
        scrollDelta = scrollDelta < 0 ? scrollDelta + diff : diff;
        if (scrollDelta < -upTolerance) {
          headerVisible = true;
          scrollDelta = 0;
        }
      }
    }

    render();
    lastScrollY = y;
  }

  // setTimeout throttle instead of requestAnimationFrame —
  // this page's heavy rAF usage from other scripts can stall/cancel rAF callbacks.
  var scheduled = false;
  function onScroll() {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        update();
        scheduled = false;
      }, 16);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('touchmove', onScroll, { passive: true });

  window.addEventListener('resize', function () {
    announcementHeight = announcement ? announcement.offsetHeight : 0;
    headerOwnHeight = header.offsetHeight;
    render();
  });
  window.addEventListener('orientationchange', function () {
    setTimeout(function () {
      announcementHeight = announcement ? announcement.offsetHeight : 0;
      headerOwnHeight = header.offsetHeight;
      render();
    }, 200);
  });

  render();
})();